// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  BASE_URL: '${BASE_URL}',
  AUTOS_LANDING_PAGE: '${AUTOS_LANDING_PAGE}',
  VD_LANDING_PAGE: '${VD_LANDING_PAGE}',
  SIGNUP_URL: '${SIGNUP_URL}',
  portalSb: '${PORTALSB}',
  portalCms: '${PORTALCMS}',
  // SonarQube: S2068 - False positive. This is a placeholder replaced by CI/CD; no real secret is stored in code.
  secretKeyCaptchaClient: '${CAPTCHASECRET}', // NOSONAR
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

